import ResponseEntity, { DtoConversionError, RequestEntity } from "../index";

export default class OutputNewsSummary extends ResponseEntity {
  constructor(
    public readonly id: number,
    public readonly name: string,
    public readonly title: string,
    public readonly content: string,
    public readonly date: Date,
    public readonly front_img: string,
    public readonly hidden: boolean
  ) {
    super(id);
  }

  static convert(input: any): OutputNewsSummary {
    if (input instanceof OutputNewsSummary) return input;

    const id = input.id ?? undefined;
    const name = input.name ?? undefined;
    const title = input.title ?? undefined;
    const content = input.content ?? undefined;
    const date = input.date ?? undefined;
    const front_img = input.front_img ?? undefined;
    const hidden = input.hidden ?? undefined;

    if (typeof id !== "number" || !Number.isInteger(id))
      throw new OutputNewsSummaryConversionError("id", input);
    if (typeof name !== "string")
      throw new OutputNewsSummaryConversionError("name", input);
    if (typeof title !== "string")
      throw new OutputNewsSummaryConversionError("title", input);
    if (typeof content !== "string")
      throw new OutputNewsSummaryConversionError("content", input);
    if (typeof date !== "string")
      throw new OutputNewsSummaryConversionError("date", input);
    if (typeof front_img !== "string")
      throw new OutputNewsSummaryConversionError("front_img", input);
    if (typeof hidden !== "boolean")
      throw new OutputNewsSummaryConversionError("hidden", input);

    return OutputNewsSummaryConversionError.propagate(
      OutputNewsSummaryConversionError.dtoName,
      () =>
        new OutputNewsSummary(
          id,
          name,
          title,
          content,
          new Date(date),
          front_img,
          hidden
        )
    );
  }
}

class OutputNewsSummaryConversionError extends DtoConversionError {
  public static dtoName: string = "OutputNewsSummary";
  constructor(propertyName: string, rawData: any, hint?: string) {
    super(
      OutputNewsSummaryConversionError.dtoName,
      propertyName,
      rawData,
      hint
    );
  }
}

export class RequestNewsCount extends RequestEntity {
  public readonly count = null;

  constructor(public readonly search?: string) {
    super();
  }
}

export class RequestNewsList extends RequestEntity {
  public readonly list = null;

  constructor(
    public readonly page?: number,
    public readonly size?: number,
    public readonly search?: string
  ) {
    super();
  }
}
